import { TextTypeEnum } from 'generated/graphql';
import type {
    PageBuilderModuleMetaProps,
    TextColumnProps,
} from '@modules/page-builder/types';
import SingleParagraphModule from '../single-paragraph-module/SingleParagraphModule';

interface QuoteModuleProp extends PageBuilderModuleMetaProps {
    column: TextColumnProps;
}

/**
 * A rendered Page Builder module for a quote.
 *
 * The editor version is at
 * {@link packages/web/app/modules/page-builder/component/edit/quote-module/QuoteModule.tsx}
 */
const QuoteModule = ({ column, meta }: QuoteModuleProp) => {
    return (
        <SingleParagraphModule
            column={column}
            meta={meta}
            textType={TextTypeEnum.Quote}
        />
    );
};

export default QuoteModule;
